<template>
  <nav class="ctabs" :aria-label="label">
    <router-link
      v-for="tab in tabs"
      :key="tab.to"
      :to="tab.to"
      class="ctabs__tab"
      :class="{ 'is-active': tab.active }"
      :aria-current="tab.active ? 'page' : null"
    >
      {{ tab.label }}
      <span v-if="tab.count" class="ctabs__count">{{ tab.count }}</span>
    </router-link>
  </nav>
</template>

<script>
/**
 * Pestañas de sección: artículos del blog y guías de uso.
 *
 * Las dos cosas son "el blog" para quien llega, aunque por dentro sean
 * distintas (los artículos los escribe el motor de SEO; las guías se mantienen
 * a mano). Con las pestañas se pasa de una a otra en un clic, en vez de
 * enterarse de que existen guías por un banner que es fácil no ver.
 */
export default {
  name: 'ContentTabs',
  props: {
    /** [{ label, to, active, count? }] */
    tabs: { type: Array, required: true },
    label: { type: String, default: '' },
  },
};
</script>

<style scoped>
.ctabs {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 44px;
}
.ctabs__tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 999px;
  border: 1px solid var(--lp-line);
  background: var(--lp-surface);
  color: var(--lp-ink-2);
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 600;
  font-size: 0.98rem;
  text-decoration: none;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}
.ctabs__tab:hover { border-color: var(--lp-line-strong); color: var(--lp-ink); }
.ctabs__tab.is-active {
  background: var(--lp-accent);
  border-color: var(--lp-accent);
  color: #fff;
}
.ctabs__count {
  font-size: 0.82rem;
  font-weight: 600;
  opacity: 0.7;
}
</style>
